import { render } from "./ShowTask.vue?vue&type=template&id=02e34b3f"
import script from "./ShowTask.vue?vue&type=script&lang=js"
export * from "./ShowTask.vue?vue&type=script&lang=js"

import "./ShowTask.vue?vue&type=style&index=0&id=02e34b3f&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\AI4IRGClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__